import es from "./locales/es.json";
import en from "./locales/en.json";
const locales = {
  en,
  es,
};
export default locales;